import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/services/api/api.service';
import { Api } from '../../../core/api/api';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(
      private _apiService: ApiService,
      private _api: Api
  ) { }

    /**
     * for view configuration
     */
    view(){
        return this._apiService.post(this._api.API.CONFIG.CONFIG_VIEW,null);
    }

    /**
     * for add edit configuration
     * @param data
     */
    addEdit(data: any){
        return this._apiService.post(this._api.API.CONFIG.CONFIG_ADD_EDIT,data);
    }
}
